<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard"> Inicio </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-9">
      <h1 class="u-mb60 txt txt--title">Notificaciones y tareas pendientes</h1>
    </div>
    <div class="col-md-3">
      <div class="u-desktop">
        <div class="form autocomplete autocomplete--small">
          <input type="text" id="iexample" class="form__search"
            placeholder="Buscar por la tarea o nombre de quién notifica" [(ngModel)]="searchText" />
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="table-task u-mb20">
        <div class="thead">
          <div class="tr">
            <div class="th hover-hand" [class.active]="order === 'task'" (click)="setOrder('task')">
              <div class="table-head">
                Tarea
                <div class="sorting-arrows-container">
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'task' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting ASC -->
                    <div [hidden]="(order === 'task' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'task' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting DESC -->
                    <div [hidden]="(order === 'task' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="th" [class.active]="order === 'commentary'" (click)="setOrder('commentary')">
              <div class="table-head">
                Comentario
                <div class="sorting-arrows-container">
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'commentary' && orderStatus === 2)"
                      style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting ASC -->
                    <div [hidden]="(order === 'commentary' && orderStatus === 2)"
                      style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'commentary' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting DESC -->
                    <div [hidden]="(order === 'commentary' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="th" [class.active]="order === 'notify'" (click)="setOrder('notify')">
              <div class="table-head">
                Quién notifica
                <div class="sorting-arrows-container">
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'notify' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting ASC -->
                    <div [hidden]="(order === 'notify' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'notify' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting DESC -->
                    <div [hidden]="(order === 'notify' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="th" [class.active]="order === 'notificationDate'" (click)="setOrder('notificationDate')">
              <div class="table-head">
                Fecha notificación
                <div class="sorting-arrows-container">
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'notificationDate' && orderStatus === 2)"
                      style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting ASC -->
                    <div [hidden]="(order === 'notificationDate' && orderStatus === 2)"
                      style="height: 11px; max-height: 11px;">
                      <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                  <div class="arrow-container">
                    <!-- Sorting Disabled -->
                    <div [hidden]="!(order === 'notificationDate' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="WHITE"></app-table-sorting-arrow>
                    </div>
                    <!-- Sorting DESC -->
                    <div [hidden]="(order === 'notificationDate' && orderStatus === 3)">
                      <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="th">
              <div class="table-head">Detalle</div>
            </div>
          </div>
        </div>


        <div class="tbody tbodyDesktop">
          <div class="tr"
            *ngFor="let task of taskPendingListApi  | filterTable:  searchText  | orderBy: order :reverse : true | paginate : config">
            <div class="td u-vat textTask" data-column="Tarea">
              <p>{{ task?.task }}</p>
            </div>
            <div class="td u-vat textTask" data-column="Comentario">
              <p>{{ task?.commentary }}</p>
            </div>
            <div class="td u-vat textTask" data-column="Quien notifica">
              <p>{{ task?.notify }}</p>
            </div>
            <div class="td u-vat textTask" data-column="Fecha notificación">
              <p>{{ task?.notificationDate | date : "dd/MM/YYYY"}} -
                {{task?.remainingDays === 0 ? 'Hoy' : task?.remainingDays + ' Días'}} </p>
            </div>
            <div class="td u-vat textTask" data-column="Detalle">
              <p><a class="hover-hand" (click)="onReviewDetail(task?.requirementId, task?.tasksCategoryId)">Revisar</a>
              </p>
            </div>
          </div>
        </div>
        <div class="tbodyMobile">
          <div class="trMobile"
            *ngFor="let task of taskPendingListApi  | filterTable: searchText | orderBy: order :reverse : true | paginate : config">
            <div class="tdMobile u-vat textTask  textTaskType">
              <p>{{ task?.task }}</p>
            </div>
            <div class="tdMobile u-vat textTask  textTaskDate">
              <p>{{ task?.notificationDate | date : "dd/MM/YYYY"}} -
                {{task?.remainingDays === 0 ? 'Hoy' : task?.remainingDays + ' Días'}}</p>
            </div>
            <div class="tdMobile u-vat textTask textTaskBodyInfo">
              <p>{{ task?.notify }}</p>
            </div>
            <div class="tdMobile u-vat textTask textTaskBodyInfo">
              <p>{{ task?.commentary }}</p>
            </div>

            <div class="containerArrowDetail hover-hand"
              (click)="onReviewDetail(task?.requirementId, task?.tasksCategoryId)">
              <span><svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.34749 10L0.623343 3.20954C-0.143252 2.53561 -0.212301 1.37466 0.469117 0.616493C1.15053 -0.141678 2.32438 -0.209969 3.09098 0.463961L12.3767 8.62721C13.2078 9.35785 13.2078 10.6422 12.3767 11.3728L3.09098 19.536C2.32438 20.21 1.15053 20.1417 0.469117 19.3835C-0.212301 18.6253 -0.143252 17.4644 0.623343 16.7905L8.34749 10Z"
                    fill="#D1D0C7" />
                </svg></span>

            </div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="gettingList" style="width: 100%; min-width: 100%; height: 60px; min-height: 60px; margin: 10px;">
        <app-loader></app-loader>
      </div>

      <!-- Loaded but no rows -->
      <div *ngIf="!gettingList && listCount === 0"
        style="width: 100%; min-width: 100%; height: 60px; min-height: 60px; margin: 10px; text-align: center">
        No tiene tareas pendientes
      </div>

      <ng-container *ngIf="taskPendingListApi">
        <div *ngIf="taskPendingListApi.length > 0" class="u-right">

          <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="config.currentPage = $event">


            <div class="custom-pagination">
              <div class="pagination-previous global-hand" [class.disabled]="p.isFirstPage()">
                <span *ngIf="!p.isFirstPage()" (click)="p.previous()">
                  < </span>
              </div>
              <div class="page-number" *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
                <span (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">{{ page.label }}</span>
                <div *ngIf="p.getCurrent() === page.value">
                  <span>{{ page.label }}</span>
                </div>
              </div>
              <div class="pagination-next global-hand" [class.disabled]="p.isLastPage()">
                <span *ngIf="!p.isLastPage()" (click)="p.next()"> > </span>
              </div>
            </div>

          </pagination-template>

        </div>
      </ng-container>
    </div>

  </div>
